import { getAnalyticsOptions } from "./analytics";

const discovered = [];

export default class Tealium {
    _tracker;
    _trackIndex;

    /**
     * @param {*} tracker - The tealium tracker object
     * @param {number} trackIndex - The trackIndex the tracker should start with
     */
    constructor(tracker, trackIndex = -1) {
        this._tracker = tracker;
        this._trackIndex = trackIndex;
    }

    get trackIndex() {
        return this._trackIndex;
    }

    /**
     * track an url or event
     * @param {string} type - The type of track
     * @param {*} payload - The tracking payload
     * @param {number} trackIndex - The index of the track event
     * @returns {Promise} - resolves when it is ok to continue tracking
     */
    track(type, payload, trackIndex) {
        this._trackIndex = trackIndex;
        if (type === 'event') {
            return this._trackEvent();
        } else if(type === 'page') {
            const type = payload.content ? (payload.content.type === 'user' ? 'kiosk' : payload.content.type) : 'unknown';
            return this._trackPage(type, payload.title);
        }
    }

    /**
     * track an url
     * @param {string} type - The type of the page
     * @param {string} title - The title of the page
     * @returns {Promise} - resolves when it is ok to continue tracking
     */
    _trackPage(type, title) {
        this._tracker.view({
            page_type: type,
            page_navigation_primary: type == 'story' ? title : '',
            page_navigation_secondary: '',
        });
        return Promise.resolve(true);
    }

    /**
     * track an event
     * @returns {Promise} - resolves when it is ok to continue tracking
     */
    _trackEvent() {
        //TODO is there event tracking in tealium?
        return Promise.resolve(true);
    }

    /**
     * destroy the tracker instance and clean up if necessary
     */
    destroy() {
        discovered.length = 0;
    }

    /**
     * repeat calls to this function will not discover the same tracker again
     * @param {number} trackIndex - The trackIndex the tracker should start with
     * @returns - A promise resolving an array of wrapper instances for discovered tracker
     */
    static discover(trackIndex = -1) {
        return new Promise((resolve, reject) => {
            if (!~discovered.indexOf("tealium") && window.tealium) {
                discovered.push("tealium");
                resolve([new Tealium(window.tealium, trackIndex)]);
            } else {
                resolve([])
            }
        });
    }

    /**
     * initialize general purpose things like the tracker's library js
     */
    static init() {
        return Promise.resolve();
    }

    /**
     * @param {*} options - The tracker options 
     * @returns - A promise resolving the wrapper instance
     */
    static create({id, domain, name}) {
        return new Promise((resolve, reject) => {
            //TODO
        })
    }
}


// WEBPACK FOOTER //
// ./lib/analytics/tracker-tealium.js